export const AppMain = {
  extends: 'CommonCard',
  flow: 'y',
  flex: '1 1 0',
  minWidth: '0',
  minHeight: '0',
  overflow: 'hidden',
  margin: '- X2 X2 -',

  Header: {
    flow: 'x',
    flex: '0 0 auto'
  },

  Body: {
    flex: '1 1 0',
    flow: 'y',
    minHeight: '0',
    overflow: 'hidden',
    position: 'relative'
  }
}
